
import LampCharge from "../../../assets/outline/LampCharge.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LampChargeIcon({ className, dataTestid = "LampChargeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <LampCharge data-testid={dataTestid} className={classes} {...rest} />
  );
}
